<template>
  <div>
    <div class="main">
      <el-form
        class="systemFont1"
        :model="limitDouponCodeForm"
        ref="limitDouponCodeFormRef"
        label-width="120px"
        style="width:100%;"
        hide-required-asterisk
      >
        <el-row>
          <el-col :span="9" :offset="1">
            <!-- 课程编号 -->
            <el-form-item
              :label="$t('p0412.courseNumber')"
              prop="courseNumber6s"
            >
              <el-select
                v-model="limitDouponCodeForm.courseNumber6s"
                size="courseSelect"
                style="width: 90%"
                :placeholder="$t('common.pleaseSelect')"
                @change="changeCourseNumber"
              >
                <el-option
                  v-for="item in courseNumberList"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <!-- 课程名称 -->
            <el-form-item
              :label="$t('p0412.courseName')"
              prop="courseName"
            >
              <el-select
                v-model="limitDouponCodeForm.courseName"
                size="courseSelect"
                style="width: 90%"
                :placeholder="$t('common.pleaseSelect')"
                @change="changeCourseName"
              >
                <el-option
                  v-for="item in courseNameList"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!-- 查询 -->
            <el-button type="submit" style="margin-left:10px" @click="getLimitCouponCode()">{{
              $t("common.query")
            }}</el-button>
            <!-- 重置 -->
            <el-button type="submit" class="buttonWidth" @click="reset">{{
              $t("common.reset")
            }}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 用户列表 -->
    <div v-if="showFlag" style="margin-top: 25px;">
      <el-table
        :data="limitCourseList"
        tooltip-effect="dark"
        style="width:95%;margin:auto"
      >
        <!-- 上课日期时间-->
        <el-table-column
          prop="dateAndTime"
          :label="$t('p0413.classDate')"
          align="center"
          :formatter="dateAndTimeFormat"
        ></el-table-column>
        <!-- 学员优惠 -->
        <el-table-column
          prop="studentDiscount"
          :label="$t('p0413.studentDiscount')"
          header-align="right"
          align="right"
        ></el-table-column>
        <!-- 介绍人佣金 -->
        <el-table-column
          prop="introducerCommission"
          :label="$t('p0413.introducerCommission')"
          header-align="right"
          align="right"
        ></el-table-column>
        <!-- 操作 -->
        <el-table-column :label="$t('common.operation')" align="center">
          <template slot-scope="scope">
            <el-button size="text" @click="editDiscount(scope.row)">{{
              $t("common.edit")
            }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      :title="$t('common.edit')"
      width="600px"
      :visible.sync="dialogFormVisible"
      :before-close="handleClose"
    >
      <el-divider></el-divider>
      <el-form :model="discountForm" ref="discountFormRef">
        <!-- 上课日期时间 -->
        <el-form-item
          :label-width="labelWidth"
          :label="$t('p0413.classDate')"
          prop="dateAndTime"
        >
          <div style="text-align: left;margin-left: 30px;">
            {{ discountForm.dateAndTime }}
          </div>
        </el-form-item>
        <!-- 学员优惠 -->
        <el-form-item :label="$t('p0412.studentDiscount')" :label-width="labelWidth">
          <el-col :span="10">
            <el-form-item label-width="0px">
              <el-radio-group v-model="discountForm.couponType" style="text-align: left;width:390px">
                <el-radio label="0" @change="changeStuNo">{{$t("p0412.deductionAmount")}}
                </el-radio>
                <el-radio label="1" @change="changeStuRate" style="margin-top:23px">{{$t("p0412.deductionRatio")}}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label-width="0px" prop="studentNumber" :rules="studentNumber" style="margin-bottom:20px;text-align: right">
              <el-input v-model="discountForm.studentNumber" @blur="formatStuNumber" size="small" style="text-align: right !important" :disabled="discountForm.couponType==1 ? true:false"></el-input>
            </el-form-item>
            <el-form-item label-width="0px" prop="studentRate" :rules="studentRate" style="text-align: right">
              <el-input v-model="discountForm.studentRate" size="small" style="text-align: right !important" :disabled="discountForm.couponType==1 ? false:true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3" :offset="1">
            <el-form-item label-width="0px" style="margin-bottom:20px"><span style="color: #606266;font-weight: 500;" >({{discountForm.couponCurrency}})</span></el-form-item>
            <el-form-item label-width="0px"><span style="color: #606266;font-weight: 500;">%</span></el-form-item>
          </el-col>
        </el-form-item>
        <!-- 介绍人佣金 -->
        <el-form-item :label-width="labelWidth" :label="$t('p0412.introducerCommission')" style="margin-top:-4px">
          <el-col :span="10">
            <el-form-item label-width="0px">
              <el-radio-group v-model="discountForm.commissionType" style="text-align: left;width:390px">
                <el-radio label="0" @change="changeIntNo">{{$t("p0412.fixedAmount")}}
                </el-radio>
                <el-radio label="1" @change="changeIntRate" style="margin-top:23px">{{$t("p0412.ratio")}}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label-width="0px" prop="introducerNumber" :rules="introducerNumber" style="margin-bottom:20px">
              <el-input v-model="discountForm.introducerNumber" @blur="formatIntNumber" size="small" style="text-align: right" :disabled="discountForm.commissionType==1 ? true:false"></el-input>
            </el-form-item>
            <el-form-item label-width="0px" prop="introducerRate" :rules="introducerRate">
              <el-input v-model="discountForm.introducerRate" size="small" style="text-align: right" :disabled="discountForm.commissionType==1 ? false:true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3" :offset="1">
            <el-form-item label-width="0px" style="margin-bottom:20px"><span style="color: #606266;font-weight: 500;">({{discountForm.commissionCurrency}})</span></el-form-item>
            <el-form-item label-width="0px"><span style="color: #606266;font-weight: 500;">%</span></el-form-item>
          </el-col>
        </el-form-item>
      </el-form>
      <el-divider></el-divider>
      <div slot="footer" style="text-align:center">
        <el-button type="submitDialog" @click.native.prevent="handleSubmit">{{
          $t("common.submit")
        }}</el-button>
        <el-button type="return"  @click.native.prevent="handleClose">{{
          $t("common.back")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs";
import moment from "moment";
export default {
  data() {
    return {
      // 标签宽度
      labelWidth: "120px",
      // 弹框
      dialogFormVisible: false,
      // 折扣表单
      discountForm: {
        dateAndTime: "",
        // 学员优惠选择
        couponType: "",
        // 学员优惠金额
        studentNumber: "",
        // 学员优惠百分比
        studentRate: "",
        // 介绍人选择
        commissionType: "",
        // 介绍人优惠金额
        introducerNumber: "",
        // 介绍人优惠百分比
        introducerRate: "",
        // 报价货币
        couponCurrency: "",
        commissionCurrency: "",
        // 优惠类别
        couponCategory: "",
        createUser:localStorage.getItem("userId"),
        // 领域
        field:"",
        // 类别
        category:"",
        // 课程编号
        courseNumber:"",
      },
      // 旧表单
      oldDiscountForm:{},
      // 学员优惠金额
      studentNumberOld: "",
      // 学员优惠百分比
      studentRateOld: "",
      // 介绍人优惠金额
      introducerNumberOld: "",
      // 介绍人优惠百分比
      introducerRateOld: "",
      // 表格显示状态
      showFlag: false,
      limitCourseList: [
        {
          dateAndTime: "",
          studentDiscount: "",
          introducerCommission: "",
          couponType:"",
          couponQuota:"",
          couponCurrency:"",
          commissionType:"",
          commissionQuota:"",
          commissionCurrency:"",
        }
      ],
      // 绿夹克上课名称列表
      courseNameList: [],
      // 绿夹克上课编号
      courseNumberList: [],
      // 限时优惠form
      limitDouponCodeForm: {
        // 领域
        field:"",
        // 类别
        category:"",
        // 课程编号
        courseNumber:"",
        courseNumber6s: "",
        // 课程名称
        courseName: "",
      },
      // 活跃的标签
      activeName: "first",
      studentNumber:[{pattern:/^(0|([1-9][0-9]*)(\.\d+)?|0(\.\d+)?)$/,message:this.$t('p0412.twoDecimals'), trigger: 'blur'}],
      studentRate:[{pattern:/^([1-9]\d|\d)$/, message:this.$t('p0412.integer'), trigger: 'blur'}],
      introducerNumber:[{pattern:/^(0|([1-9][0-9]*)(\.\d+)?|0(\.\d+)?)$/, message:this.$t('p0412.twoDecimals'), trigger: 'blur'}],
      introducerRate:[{pattern:/^([1-9]\d|\d)$/, message:this.$t('p0412.integer'), trigger: 'blur'}],
    };
  },
  methods: {
    // 选择的标签
    handleClick(tab, event) {
      console.log(tab, event);
    },
    
    // 初始化
    initData(){
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container"),
      });
      let url = "/api/couponCode/initCoupon";
      this.$http
        .post(
          url
        )
        .then((response) => {
          // 课程编号下拉框数据
          this.courseNumberList = response.data.data.courseNumberList;
          // 课程名称下拉框数据
          this.courseNameList = response.data.data.courseNameList;
          loading.close();
        })
        .catch((err) => {
          loading.close();
          console.log(err);
          this.$message.error(this.$t("p0211.errorOccurred"));
        });
    },
    // 改变课程编号
    changeCourseNumber(){
      // const loading = this.$loading({
      //   lock: true,
      //   text: this.$t("common.loading"),
      //   background: "rgba(255,255,255,0.8)",
      //   target: document.querySelector("#main-container"),
      // });
      let url = "/api/couponCode/changeNumber";
      this.$http
        .post(
          url,qs.stringify({courseNumber6s:this.limitDouponCodeForm.courseNumber6s})
        )
        .then((response) => {
          // console.log("response:" + JSON.stringify(response.data.data));
          this.limitDouponCodeForm.field=response.data.data.field
          this.limitDouponCodeForm.category=response.data.data.category
          this.limitDouponCodeForm.courseNumber=response.data.data.courseNumber
          this.limitDouponCodeForm.courseName=response.data.data.courseName
          // loading.close();
        })
        .catch((err) => {
          // loading.close();
          console.log(err);
          this.$message.error(this.$t("p0211.errorOccurred"));
        });
    },
    // 改变课程名称
    changeCourseName(){
      // const loading = this.$loading({
      //   lock: true,
      //   text: this.$t("common.loading"),
      //   background: "rgba(255,255,255,0.8)",
      //   target: document.querySelector("#main-container"),
      // });
      let url = "/api/couponCode/changeName";
      this.$http
        .post(
          url,qs.stringify({courseName:this.limitDouponCodeForm.courseName})
        )
        .then((response) => {
          // console.log("response:" + JSON.stringify(response.data.data));
          this.limitDouponCodeForm.field=response.data.data.field
          this.limitDouponCodeForm.category=response.data.data.category
          this.limitDouponCodeForm.courseNumber=response.data.data.courseNumber
          this.limitDouponCodeForm.courseNumber6s=response.data.data.courseNumber6s
          // loading.close();
        })
        .catch((err) => {
          // loading.close();
          console.log(err);
          this.$message.error(this.$t("p0211.errorOccurred"));
        });
    },
    // 4.排课一览及对应优惠取得
    getLimitCouponCode(){
      if(this.limitDouponCodeForm.courseNumber6s==null||this.limitDouponCodeForm.courseNumber6s==""){
        this.$message.error(this.$t("p0413.selectCourse"))
        this.showFlag = false
        return
      }
      this.showFlag = true;
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container"),
      });
      let url = "/api/couponCode/getLimitCouponCode";
      this.$http
        .post(
          url,qs.stringify({courseNumber6s:this.limitDouponCodeForm.courseNumber6s})
        )
        .then((response) => {
          // console.log("response:" + JSON.stringify(response.data.data.limitCourseList));
          if(response.data.data.limitCourseList!=null && response.data.data.limitCourseList.length >0){
            this.limitCourseList=response.data.data.limitCourseList
            for(let i=0;i<this.limitCourseList.length;i++){
              // 学员优惠
              if(this.limitCourseList[i].couponQuota==null||this.limitCourseList[i].couponQuota==""){
                if(this.limitCourseList[i].couponQuota==0){
                  if(this.limitCourseList[i].couponType==0){
                    this.limitCourseList[i].studentDiscount="0.00 " + this.limitCourseList[i].currencyValue
                  }else{
                    this.limitCourseList[i].studentDiscount="0%"
                  }
                }else{
                  this.limitCourseList[i].studentDiscount="-"
                }
              }else{
                if(this.limitCourseList[i].couponType==0){
                  if(this.limitCourseList[i].couponQuota==0){
                      this.limitCourseList[i].couponQuota="0.00";
                    }else{
                      if (this.limitCourseList[i].couponQuota.toString().includes(".")) {
                        this.limitCourseList[i].couponQuota = this.limitCourseList[i].couponQuota.toString().split(".")[1].length < 2 ? (this.limitCourseList[i].couponQuota.toString().split(".")[1].length < 1 ? this.limitCourseList[i].couponQuota.toString() + "00" : this.limitCourseList[i].couponQuota.toString() + "0") : this.limitCourseList[i].couponQuota;
                      }else{
                        this.limitCourseList[i].couponQuota=this.limitCourseList[i].couponQuota.toString()+".00"
                      }
                    }
                  this.limitCourseList[i].studentDiscount=this.limitCourseList[i].couponQuota+" " + this.limitCourseList[i].currencyValue
                }else{
                  this.limitCourseList[i].studentDiscount=this.limitCourseList[i].couponQuota+"%"
                }
              }
              // 介绍人佣金
              if(this.limitCourseList[i].commissionQuota==null||this.limitCourseList[i].commissionQuota==""){
                if(this.limitCourseList[i].commissionQuota==0){
                  if(this.limitCourseList[i].couponType==0){
                    this.limitCourseList[i].introducerCommission="0.00 " + this.limitCourseList[i].currencyValue
                  }else{
                    this.limitCourseList[i].introducerCommission="0%"
                  }
                }else{
                  this.limitCourseList[i].introducerCommission="-"
                }
              }else{
                if(this.limitCourseList[i].commissionType==0){
                  if(this.limitCourseList[i].commissionQuota==0){
                      this.limitCourseList[i].commissionQuota="0.00";
                    }else{
                      if (this.limitCourseList[i].commissionQuota.toString().includes(".")) {
                        this.limitCourseList[i].commissionQuota = this.limitCourseList[i].commissionQuota.toString().split(".")[1].length < 2 ? (this.limitCourseList[i].commissionQuota.toString().split(".")[1].length < 1 ? this.limitCourseList[i].commissionQuota.toString() + "00" : this.limitCourseList[i].commissionQuota.toString() + "0") : this.limitCourseList[i].commissionQuota;
                      }else{
                        this.limitCourseList[i].commissionQuota=this.limitCourseList[i].commissionQuota.toString()+".00"
                      }
                    }
                  this.limitCourseList[i].introducerCommission=this.limitCourseList[i].commissionQuota+" "+ this.limitCourseList[i].currencyValue
                }else{
                  this.limitCourseList[i].introducerCommission=this.limitCourseList[i].commissionQuota+"%"
                }
              }
            }
          }else{
            this.limitCourseList=[]
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
          console.log(err);
          this.$message.error(this.$t("p0211.errorOccurred"));
        });
      
    },
    //格式化时间
    dateAndTimeFormat(row) {
      if(row.dateAndTime!=null && row.dateAndTime!=""){
        return moment(row.dateAndTime).format("YYYY-MM-DD HH:mm");
      }
    },
    // 重置
    reset() {
      this.$refs.limitDouponCodeFormRef.resetFields();
      this.showFlag = false;
      this.initData()
    },
    // 编辑
    editDiscount(row) {
      this.discountForm.dateAndTime= moment(row.dateAndTime).format("YYYY-MM-DD HH:mm");
      this.discountForm.couponCurrency=row.currencyValue
      this.discountForm.commissionCurrency=row.currencyValue
      this.discountForm.couponCategory=row.couponCategory
      this.discountForm.field=row.field
      this.discountForm.category=row.category
      this.discountForm.courseNumber=row.courseNumber
      this.discountForm.currency=row.currency
      // 学生优惠
      if(row.couponType!=1){
        // 金额
        this.discountForm.couponType="0"
        if(row.couponQuota!=null && row.couponQuota!=""){
          // 货币格式
          if(row.couponQuota==0){
            this.discountForm.studentNumber="0.00";
          }else{
            if (row.couponQuota.toString().includes(".")) {
              this.discountForm.studentNumber = row.couponQuota.toString().split(".")[1].length < 2 ? row.couponQuota.toString() + "0" : row.couponQuota;
            }else{
              this.discountForm.studentNumber=row.couponQuota.toString()+".00"
            }
          }
        }else if(row.couponQuota==0){
          this.discountForm.studentNumber="0.00";
        }else{
          this.discountForm.studentNumber=row.couponQuota
        }
        this.discountForm.studentRate=""
      }else{
        // %
        this.discountForm.couponType=row.couponType
        this.discountForm.studentRate=row.couponQuota
        this.discountForm.studentNumber=""
      }
      // 佣金
      if(row.commissionType!=1){
        // 金额
        this.discountForm.commissionType="0"
        if(row.commissionQuota!=null && row.commissionQuota!=""){
          // 货币格式
          if(row.commissionQuota==0){
            this.discountForm.introducerNumber="0.00";
          }else{
            if (row.commissionQuota.toString().includes(".")) {
              this.discountForm.introducerNumber = row.commissionQuota.toString().split(".")[1].length < 2 ? row.commissionQuota.toString() + "0" : row.commissionQuota;
            }else{
              this.discountForm.introducerNumber=row.commissionQuota.toString()+".00"
            }
          }
        }else if(row.commissionQuota==0){
          this.discountForm.introducerNumber="0.00";
        }else{
          this.discountForm.introducerNumber=row.commissionQuota
        }
        this.discountForm.introducerRate=""
      }else{
        // %
        this.discountForm.commissionType=row.commissionType
        this.discountForm.introducerRate=row.commissionQuota
        this.discountForm.introducerNumber=""
      }
      this.oldDiscountForm=JSON.stringify(this.discountForm);
      this.studentNumberOld=this.discountForm.studentNumber
      this.studentRateOld=this.discountForm.studentRate
      this.introducerNumberOld=this.discountForm.introducerNumber
      this.introducerRateOld=this.discountForm.introducerRate
      this.dialogFormVisible = true;
    },
    // 比较数据是否发生变更
    discountFormChanged() {
      if (this.oldDiscountForm===JSON.stringify(this.discountForm)) {
        this.$message({
          message: this.$t('common.contentIsUnchanged'),
          type: "warning",
        });
        return true;
      }
      return false;
    },
    // 提交
    handleSubmit(){
      this.$refs["discountFormRef"].validate((valid) => {
        if (valid) {
          if(this.discountFormChanged()){
            return
          }
          const loading = this.$loading({
            lock: true,
            text: this.$t("common.loading"),
            background: "rgba(255,255,255,0.8)",
            target: document.querySelector("#main-container"),
          });
          this.discountForm.dateAndTime= moment(this.discountForm.dateAndTime).format("YYYY-MM-DD HH:mm:ss");
          let url = "/api/couponCode/submitLimitCoupon";
          this.$http
            .post(
              url,this.discountForm
            )
            .then((response) => {
              if (response.data.code === 200){
                // this.$message.success(response.data.message);
                this.getLimitCouponCode()
                this.$message.success(this.$t("p0413.LimitSetSuccess"));
              }else{
                this.$message.error(response.data.message);
              }
              loading.close();
            })
            .catch((err) => {
              loading.close();
              console.log(err);
              this.$message.error(this.$t("common.anErrorOccurred"));
            });
            // 关闭弹窗
            this.handleClose()
        }
      })
    },
    // 改变优惠方式
    changeStuNo(){
      this.discountForm.studentRate=""
      this.discountForm.studentNumber=this.studentNumberOld
      this.$refs.discountFormRef.clearValidate('studentRate')
      
    },
    changeStuRate(){
      this.discountForm.studentNumber=""
      this.discountForm.studentRate=this.studentRateOld
      this.$refs.discountFormRef.clearValidate('studentNumber')
    },
    changeIntNo(){
      this.discountForm.introducerRate=""
      this.discountForm.introducerNumber=this.introducerNumberOld
      this.$refs.discountFormRef.clearValidate('introducerRate')
    },
    changeIntRate(){
      this.discountForm.introducerNumber=""
      this.discountForm.introducerRate=this.introducerRateOld
      this.$refs.discountFormRef.clearValidate('introducerNumber')
    },
    formatStuNumber(){
      this.$refs["discountFormRef"].validateField("studentNumber",(valid) => {
        if (!valid) {
          if(this.discountForm.studentNumber!=null && this.discountForm.studentNumber!=""){
            // 货币格式
            if(this.discountForm.studentNumber==0){
              this.discountForm.studentNumber="0.00";
            }else{
              if (this.discountForm.studentNumber.toString().includes(".")) {
                this.discountForm.studentNumber = this.discountForm.studentNumber.toString().split(".")[1].length < 2 ? ( this.discountForm.studentNumber.toString().split(".")[1].length < 1 ? this.discountForm.studentNumber.toString() + "00" : this.discountForm.studentNumber.toString() + "0") : this.discountForm.studentNumber;
              }else{
                this.discountForm.studentNumber=this.discountForm.studentNumber.toString()+".00"
              }
            }
          }
        }
      })
    },
    formatIntNumber(){
      this.$refs["discountFormRef"].validateField("introducerNumber",(valid) => {
        if (!valid) {
          if(this.discountForm.introducerNumber!=null && this.discountForm.introducerNumber!=""){
            // 货币格式
            if(this.discountForm.introducerNumber==0){
              this.discountForm.introducerNumber="0.00";
            }else{
              if (this.discountForm.introducerNumber.toString().includes(".")) {
                this.discountForm.introducerNumber = this.discountForm.introducerNumber.toString().split(".")[1].length < 2 ? (this.discountForm.introducerNumber.toString().split(".")[1].length < 1 ? this.discountForm.introducerNumber.toString() + "00" : this.discountForm.introducerNumber.toString() + "0") : this.discountForm.introducerNumber;
              }else{
                this.discountForm.introducerNumber=this.discountForm.introducerNumber.toString()+".00"
              }
            }
          }
        }
      })
    },
    // 关闭弹窗，清除数据
    handleClose(){
      this.dialogFormVisible = false;
      this.$refs.discountFormRef.resetFields();
      this.discountForm.studentNumber=""
      this.discountForm.studentRate=""
      this.discountForm.introducerNumber=""
      this.discountForm.introducerRate=""
    },
  },
  mounted() {
    this.initData()
  }
};
</script>

<style lang="scss" scoped>
.main {
  width: 90%;
  margin: 0 auto;
  padding-top: 17px;
  display: flex;
}
>>> .el-button--submit {
  width: 80px;
  height: 32px;
  margin-top: 4px;
}
>>> .buttonWidth {
  width: 80px;
  height: 32px;
  background-color: rgb(255, 255, 255);
  color: rgb(0, 176, 240);
}
>>> .el-table__row {
  height: 42px;
}
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 16px;
}
>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  line-height: 18px;
  border-bottom: 0.5px solid rgb(170, 170, 170);
}
>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}
>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}
>>> .el-tabs__item {
  font-size: 15px;
}
>>> .el-radio {
  display: block;
  line-height: 40px;
  white-space: normal;
  margin-right: 0;
}
.spanWidth {
  min-width: 150px;
  display: inline-block;
}
.spanWidth1 {
  min-width: 50px;
  display: inline-block;
}
>>>.el-input--small .el-input__inner{
  text-align: right
}
>>>.el-dialog__body{
  padding: 0 10px;
}
>>>.el-divider--horizontal{
  margin: 14px 0;
}
/* 提交 */
.el-button--submitDialog {
  background-color: #00B0F0;
  border-color: rgb(0, 176, 240);
  width: 61px;
  height: 26px;
  white-space: pre-wrap;
  padding: 0;
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  color: #FFFFFF;
  font-size: 13px;
  line-height: 18px;
}
</style>



// WEBPACK FOOTER //
// src/views/Marketing/CouponCode/P0414.vue